import { render, staticRenderFns } from "./GalleryEditor.vue?vue&type=template&id=6e648264&scoped=true&"
import script from "./GalleryEditor.vue?vue&type=script&lang=js&"
export * from "./GalleryEditor.vue?vue&type=script&lang=js&"
import style0 from "./GalleryEditor.vue?vue&type=style&index=0&id=6e648264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e648264",
  null
  
)

export default component.exports